import {
    LICENCE_CATEGORY,
    FREQUENCY_ENTRY,
    OTHER_DETAILS,
    BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION,
    STATION,
    BASED_LAND_FIXED_STATION_INFORMATION,
    STATION_ADDRESS,
    LATITUDE,
    LONGITUDE,
    VENDOR_INFORMATION,
    VENDOR_ADDRESS,
    RADIO_EQUIPMENT_INFORMATION,
    ANTENNA_INFORMATION,
    ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION,
    FILTER_INFORMATION,
    FEEDER_INFORMATION,
    FREQUENCY_AND_EMISSION_CLASS_INFORMATION,
    MOBILE,
    MOBILE_PORTABLE_STATION_APPLICATION,
    MOBILE_LATITUDE,
    MOBILE_LONGITUDE,
    MOBILE_FREQUENCY_INFORMATION,
    SUPPORTING_DOCUMENTS
} from '../../../../common/application.const/Licence/MyLicence/WPNLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatWPN = async (
    licenceDetails: any,
    caseTypeID: string,
    application?: string,
    totalNoOfStations?: string,
    transactionType?: any
) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let baseLandFixedStationInfoList = [];
    let stationList = [];
    let mobileStationList = [];
    let mobilePortableStationApplicationList = [];
    let coverageInformation: any = [];
    let mobilesCommunicateWith: any = [];
    let portablesCommunicateWith: any = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        baseLandFixedStationInfoList = licenceDetails?.baseLandFixedStationInfo?.map((value: Record<string, any>, index: number) => ({
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-call-sign`]: value?.callSign ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-station-name`]: value?.stationName ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-location-of-station`]: value?.locationOfStationEGRooftop ?? '-',
            [`${BASED_LAND_FIXED_STATION_INFORMATION}-date-of-comissioning`]: value?.DateofCommissioning ?? '-',

            [`${STATION_ADDRESS}-building-name`]: value?.stationAddress?.buildingName ?? '-',
            [`${STATION_ADDRESS}-postal-code`]: value?.stationAddress?.postalCode ?? '-',
            [`${STATION_ADDRESS}-street-name`]: value?.stationAddress?.streetName ?? '-',
            [`${STATION_ADDRESS}-block-house-no`]: value?.stationAddress?.blockNo ?? '-',
            [`${STATION_ADDRESS}-unit`]: value?.stationAddress?.unit ?? '-',
            [`${STATION_ADDRESS}-floor-level`]: value?.stationAddress?.floor ?? '-',

            [`${LATITUDE}-latitude-degrees`]: value?.LatitudeDegreesDesc ?? '-',
            [`${LATITUDE}-latitude-minutes`]: value?.latitudeMinutes ?? '-',
            [`${LATITUDE}-latitude-seconds`]: value?.latitudeSeconds ?? '-',

            [`${LONGITUDE}-longitude-degrees`]: value?.longitudeDegrees ?? '-',
            [`${LONGITUDE}-longitude-minutes`]: value?.longitudeMinutes ?? '-',
            [`${LONGITUDE}-longitude-seconds`]: value?.longitudeSeconds ?? '-',

            [`${LONGITUDE}-building-height`]: value?.buildingHeightM ?? '-',
            [`${LONGITUDE}-antenna-effective-height`]: value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
            [`${LONGITUDE}-elavation-above-mean-sea-level`]: value?.elevationAboveMeanSeaLevelM ?? '-',
            [`${LONGITUDE}-transportable`]: value?.transportable ?? '-',
            [`${LONGITUDE}-station-antenna-elevation-angle`]:
                value?.stationAntennaElevationAngleWithReferenceToHorizontalPlaneDegree ?? '-',
            [`${LONGITUDE}-coverage-radius-link-distance`]: value?.coverageRadiusLinkDistanceKm ?? '-',

            [`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-transmitter`]: value?.manufacturerTransmitter ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-manufacturer-receiver`]: value?.manufacturerReceiver ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-model-transmitter`]: value?.modelTransmitter ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-model-receiver`]: value?.modelReceiver ?? '-',
            [`${RADIO_EQUIPMENT_INFORMATION}-output-power`]: value?.outputPowerWTransmitter ?? '-',

            [`${ANTENNA_INFORMATION}-antenna-manufacturer`]: value?.antennaManufacturer ?? '-',
            [`${ANTENNA_INFORMATION}-polarization`]: value?.PolarizationDesc ?? '-',
            [`${ANTENNA_INFORMATION}-if-others-please-specifiy`]: value?.ifOthersPleaseSpecify ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-effective-height`]: value?.antennaEffectiveHeightMAboveGroundLevel ?? '-',
            [`${ANTENNA_INFORMATION}-antenna-elevation-angle`]: value?.antennaElevationAngleWithReferenceToHorizontalPlaneDegree ?? '-',

            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-north-latitude-displacement`]: value?.northLatitudeDisplacementM ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-east-longitude-displacement`]: value?.eastLongitudeDisplacementM ?? '-',
            [`${ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION}-gain-db`]: value?.gainDB ?? '-',

            [`${FILTER_INFORMATION}-filter-manufacturer`]: value?.filterManufacturer ?? '-',
            [`${FILTER_INFORMATION}-model`]: value?.model ?? '-',
            [`${FILTER_INFORMATION}-insertion-loss`]: value?.insertionLossDB ?? '-',
            [`${FILTER_INFORMATION}-tuned-frequency`]: value?.tunedFrequencyMHz ?? '-',

            [`${FEEDER_INFORMATION}-feeder-line-type-transmit`]: value?.feederLineTypeTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-type-receive`]: value?.feederLineTypeReceive ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-length-transmit`]: value?.feederLineLengthMTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-length-receive`]: value?.feederLineLengthMReceive ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-loss-transmit`]: value?.feederLineLossDBTransmit ?? '-',
            [`${FEEDER_INFORMATION}-feeder-line-loss-receive`]: value?.feederLineLossDBReceive ?? '-',

            [`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`]:
                (value?.frequencyInformationBaseLandFixedStation ?? []).map((i: any, index: number) => {
                    return {
                        sn: i?.rowId,
                        'desired-frequency-mhz-from-tx': i?.desiredFrequencyMHzFromTransmit ?? '-',
                        'desired-frequency-mhz-to-tx': i?.desiredFrequencyMHzToTransmit ?? '-',
                        'desired-frequency-mhz-from-rx': i?.desiredFrequencyMHzFromReceive ?? '-',
                        'desired-frequency-mhz-to-rx': i?.desiredFrequencyMHzToReceive ?? '-',
                        'desired-bandwidth-khz-tx': i?.bandwidthKHzTransmit ?? '-',
                        'desired-bandwidth-khz-rx': i?.bandwidthKHzReceive ?? '-',
                        'start-time': i?.startTime ?? '-',
                        'stop-time': i?.stopTime ?? '-',
                        'emission-class-transmit': i?.emissionClassTransmit ?? '-',
                        'emission-class-receive': i?.emissionClassReceive ?? '-'
                    };
                }) ?? '-'
        }));
    }

    if (licenceDetails && licenceDetails.mobilePortableStationApplication && licenceDetails.mobilePortableStationApplication.length > 0) {
        coverageInformation = licenceDetails?.mobilePortableStationApplication[0]?.coverageInformationPageLst?.map(
            (i: any) => i.mixedValue
        );
    }

    if (licenceDetails && licenceDetails.mobilePortableStationApplication && licenceDetails.mobilePortableStationApplication.length > 0) {
        mobilesCommunicateWith = licenceDetails?.mobilePortableStationApplication[0]?.mobileSCommunicateWith?.map((i: any) => i.mixedValue);
    }

    if (licenceDetails && licenceDetails.mobilePortableStationApplication && licenceDetails.mobilePortableStationApplication.length > 0) {
        portablesCommunicateWith = licenceDetails?.mobilePortableStationApplication[0]?.portableSCommunicateWith?.map(
            (i: any) => i.mixedValue
        );
    }

    if (licenceDetails && licenceDetails.mobilePortableStationApplication && licenceDetails.mobilePortableStationApplication.length > 0) {
        mobilePortableStationApplicationList = licenceDetails?.mobilePortableStationApplication?.map(
            (value: Record<string, any>, index: number) => ({
                [`${MOBILE_PORTABLE_STATION_APPLICATION}-date-of-commissioning`]: value?.DateofCommissioning ?? '-',
                [`${MOBILE_PORTABLE_STATION_APPLICATION}-no-of-mobiles`]: value?.noOfMobiles ?? '-',
                [`${MOBILE_PORTABLE_STATION_APPLICATION}-coverage-information`]: coverageInformation ?? [],
                [`${MOBILE_PORTABLE_STATION_APPLICATION}-mobiles-communicate-with`]: mobilesCommunicateWith ?? [],
                [`${MOBILE_PORTABLE_STATION_APPLICATION}-portables-communicate-with`]: portablesCommunicateWith ?? [],

                [`${MOBILE_LATITUDE}-latitude-degrees`]: value?.LatitudeDegreesDesc ?? '-',
                [`${MOBILE_LATITUDE}-latitude-minutes`]: value?.latitudeMinutes ?? '-',
                [`${MOBILE_LATITUDE}-latitude-seconds`]: value?.latitudeSeconds ?? '-',

                [`${MOBILE_LONGITUDE}-longitude-degrees`]: value?.longitudeDegrees ?? '-',
                [`${MOBILE_LONGITUDE}-longitude-minutes`]: value?.longitudeMinutes ?? '-',
                [`${MOBILE_LONGITUDE}-longitude-seconds`]: value?.longitudeSeconds ?? '-',
                [`${MOBILE_LONGITUDE}-radius-of-operation`]: value?.radiusOfOperationKm ?? '-',

                [`${MOBILE_FREQUENCY_INFORMATION}-list`]:
                    (value?.frequencyInformationMobilePortableStation ?? []).map((i: any, index: number) => {
                        return {
                            sn: i?.rowId,
                            'desired-frequency-mhz-from-tx': i?.desiredFrequencyMHzFromTransmit ?? '-',
                            'desired-frequency-mhz-to-tx': i?.desiredFrequencyMHzToTransmit ?? '-',
                            'desired-frequency-mhz-from-rx': i?.desiredFrequencyMHzFromReceive ?? '-',
                            'desired-frequency-mhz-to-rx': i?.desiredFrequencyMHzToReceive ?? '-',
                            'desired-bandwidth-khz-tx': i?.bandwidthKHzTransmit ?? '-',
                            'desired-bandwidth-khz-rx': i?.bandwidthKHzReceive ?? '-',
                            'start-time': i?.startTime ?? '-',
                            'stop-time': i?.stopTime ?? '-',
                            manufacturer: i?.manufacturer ?? '-',
                            model: i?.model ?? '-',
                            'equipment-type': i?.EquipmentTypeDesc ?? '-',
                            'emission-class-transmit': i?.emissionClassTransmit ?? '-',
                            'emission-class-receive': i?.emissionClassReceive ?? '-'
                        };
                    }) ?? '-'
            })
        );
    }

    if (licenceDetails && licenceDetails.baseLandFixedStationInfo && licenceDetails.baseLandFixedStationInfo.length > 0) {
        stationList = licenceDetails?.baseLandFixedStationInfo?.map((value: Record<string, any>, index: number) => {
            const list = {
                id: index + 1,
                label: value?.stationName
            };

            return list;
        });
    }

    if (licenceDetails && licenceDetails.mobilePortableStationApplication && licenceDetails.mobilePortableStationApplication.length > 0) {
        mobileStationList = licenceDetails?.mobilePortableStationApplication?.map((value: Record<string, any>, index: number) => {
            const list = {
                id: index + 1,
                label: value?.stationName
            };

            return list;
        });
    }

    licence = {
        id: 'wide-area-private-network',
        formID: 'wide-area-private-network',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',

            [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
            [`${OTHER_DETAILS}-remarks-by-applicant`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${VENDOR_INFORMATION}-company-name`]: licenceDetails?.vendorInformation?.CompanyName ?? '-',
            [`${VENDOR_INFORMATION}-vendor-dealers-licence-number`]: licenceDetails?.vendorInformation?.vendorSDealerSLicenceNumber ?? '-',
            [`${VENDOR_INFORMATION}-contact-person`]: licenceDetails?.vendorInformation?.contactPersonName ?? '-',
            [`${VENDOR_INFORMATION}-contact-number`]: licenceDetails?.vendorInformation?.ContactNumber ?? '-',

            [`${VENDOR_ADDRESS}-building-name`]: licenceDetails?.vendorInformation?.address?.buildingName ?? '-',
            [`${VENDOR_ADDRESS}-postal-code`]: licenceDetails?.vendorInformation?.address?.postalCode ?? '-',
            [`${VENDOR_ADDRESS}-street-name`]: licenceDetails?.vendorInformation?.address?.streetName ?? '-',
            [`${VENDOR_ADDRESS}-block-house-no`]: licenceDetails?.vendorInformation?.address?.blockNo ?? '-',
            [`${VENDOR_ADDRESS}-unit`]: licenceDetails?.vendorInformation?.address?.unit ?? '-',
            [`${VENDOR_ADDRESS}-floor-level`]: licenceDetails?.vendorInformation?.address?.floor ?? '-',

            [`${BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION}-station-type`]:
                licenceDetails?.baseLandFixedStationWithMobilePortableStation?.stationType ?? '-',

            [`${STATION}-station-name`]: stationList ?? '-',
            [`${STATION}-total-number-of-stations`]: totalNoOfStations ?? '-',

            [`${BASED_LAND_FIXED_STATION_INFORMATION}-list`]: baseLandFixedStationInfoList ?? [...baseLandFixedStationInfoList],
            [`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`]:
                baseLandFixedStationInfoList.length > 0 &&
                baseLandFixedStationInfoList[0][`${FREQUENCY_AND_EMISSION_CLASS_INFORMATION}-list`],

            [`${MOBILE}-portable-name`]: mobileStationList ?? '-',

            [`${MOBILE_PORTABLE_STATION_APPLICATION}-list`]: mobilePortableStationApplicationList ?? [
                ...mobilePortableStationApplicationList
            ],
            [`${MOBILE_FREQUENCY_INFORMATION}-list`]:
                mobilePortableStationApplicationList.length > 0 &&
                mobilePortableStationApplicationList[0][`${MOBILE_FREQUENCY_INFORMATION}-list`],

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const wpnPayload = {
    formatWPN
};

export default wpnPayload;
